import { EventBookingDetails } from '@/modals/event-details/eventBookingDetails';
import { Volunteer } from '@/modals/volunteer';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AesEncryptionService } from '@services/aes-encryption.service';
import { AppService } from '@services/app.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-volunteer-list',
  templateUrl: './volunteer-list.component.html',
  styleUrl: './volunteer-list.component.scss'
})
export class VolunteerListComponent {
  destroy$: Subject<boolean> = new Subject<boolean>();

  eventDetails: EventBookingDetails[] = [];

  volunteerDetails: Volunteer[] = [];

  volunteerDetailList: Volunteer[] = [];

  searchText;

  constructor(
    private appService: AppService, private router: Router,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private aesService: AesEncryptionService
  ) {

  }
  ngOnInit(): void {
    this.eventDetailsGetAll();
  }

  eventDetailsGetAll() {
    this.spinner.show();
    this.appService.eventDetailsGetAll()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        const today = new Date().setHours(0, 0, 0, 0);
        const sorted = data
          .sort((a, b) => {
            const aIsFuture = a.startDate >= today;
            const bIsFuture = b.startDate >= today;
            if (aIsFuture && !bIsFuture) return -1;
            if (!aIsFuture && bIsFuture) return 1;
            return a.startDate - b.startDate;
          });
        this.eventDetails = sorted;
        this.spinner.hide();
      }, (error: any) => {
        this.spinner.hide()
        this.toastr.error(error?.error?.message || "Something Went Wrong, Please Try Again")
      });
  }


  selectValue(event: any) {
    const selectedEventId = Number(event.target.value);
    this.getAllVolunteersByAdmin(selectedEventId)
  }

  formattedDate(epoch: number): string {
    const date = new Date(epoch);
    return date.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric'
    });
  }


  getAllVolunteersByAdmin(eventId : number) {
    this.spinner.show();
    this.appService.volunteerDetailsGetByEventId(eventId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((volunteers) => {
        this.volunteerDetails = volunteers;

        this.volunteerDetailList = [... this.volunteerDetails];

        console.log(`volunteerdetails::`, this.volunteerDetailList);
        this.spinner.hide();
      },
        (error: any) => {
          this.spinner.hide()
          this.toastr.error(error?.error?.message || error?.message || "Something Went Wrong, Please Try Again");
        });
  }

  generateExcelSheet() {

    if (!this.volunteerDetailList || this.volunteerDetailList.length === 0) {
      this.toastr.warning("No Data Found to Download!");
      return;
    }

    // Convert data to Excel-friendly JSON
    const formattedData = this.volunteerDetailList.map((item: any, index) => {
      return {
        'S.No': index + 1,
        "Name": item.name,
        "Gender": item.gender,
        "Age": item.age,
        "Phone Number": item.phone,
        "WhatsApp Number": item.whatsappNumber,
        "Email": item.email,
        "City": item.city,
        "District": item.district,
        "State": item.state,
      };
    });

    // Convert JSON → Worksheet
    const worksheet = XLSX.utils.json_to_sheet(formattedData);

    // Create Workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Volunteers");

    // Export as Excel
    XLSX.writeFile(workbook, `Volunteer_List.xlsx`);
  }

}
